import {
  Dashboard,
  DashboardFolder,
  ReFolderV2,
  ResourceExplorer,
} from "@/services/cloudchipr.api";
import { VisibilityType } from "@/components/pages/common/hierarchy-all-items/utils/types/types";
import { isHierarchyFolder } from "@/store/navigation/utils/helpers/isHierarchyFolder";

export const getHierarchyAllItemsFolderChildren = (
  view: DashboardFolder | Dashboard | ReFolderV2 | ResourceExplorer,
  visibility: VisibilityType,
) => {
  const folder =
    isHierarchyFolder(view) && view.items?.length
      ? view.items
      : [
          {
            id: `${view.id}-${hierarchyFolderNoItemsText}`,
            name: hierarchyFolderNoItemsText,
            created_by: view.created_by,
            created_at: view.created_at,
            visibility,
          },
        ];

  return isHierarchyFolder(view) ? folder : undefined;
};

export const hierarchyFolderNoItemsText = "c8r-folder-no-items";
